exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-show-treatment .modal-dialog{max-width:768px}#customer-show-treatment .selected-teeth{margin-top:7px}#customer-show-treatment .modal-header{padding-bottom:0!important}#customer-show-treatment .modal-body{padding-top:0!important}#customer-show-treatment .customer-name{margin-bottom:16px;font-size:16px;line-height:1.25;color:var(--theme-text-color)}#customer-show-treatment .status-check{flex:0 0 120px}", ""]);

// exports
